import {
  IonContent,
  IonPage,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonSpinner,
  IonText,
  IonList,
} from '@ionic/react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client/react';
import { GET_MY_CHANNEL_FOLLOWERS } from '../../../../graphql/queries/channelFollowers';
import type { GetMyChannelFollowersQuery } from '../../../../types/graphql-generated';
import { AppSectionHeader } from '../../../components/ui/AppSectionHeader';
import { FollowerCard } from './FollowerCard';

export const ChannelFollowers: React.FC = () => {
  const channelId = useParams<'channelId'>().channelId!;
  const { data, loading, error } = useQuery<GetMyChannelFollowersQuery>(GET_MY_CHANNEL_FOLLOWERS, {
    variables: { channelId },
  });

  const followers = data?.myChannel?.followers ?? [];

  const renderBody = () => {
    if (loading) {
      return (
        <div className="flex justify-center items-center min-h-[200px]">
          <IonSpinner name="crescent" />
        </div>
      );
    }

    if (error) {
      return (
        <IonText color="danger">
          <p>Error al cargar los seguidores</p>
        </IonText>
      );
    }

    if (followers.length === 0) {
      return (
        <IonText>
          <p>Aún no tienes seguidores</p>
        </IonText>
      );
    }

    return (
      <IonList>
        {followers.map((follower) => (
          <FollowerCard key={follower.id} follower={follower} />
        ))}
      </IonList>
    );
  };

  return (
    <IonPage>
      <AppSectionHeader variant="main">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/app/main/perfil" />
          </IonButtons>
          <IonTitle className="ml-4">Seguidores</IonTitle>
        </IonToolbar>
      </AppSectionHeader>

      <IonContent className="ion-padding">{renderBody()}</IonContent>
    </IonPage>
  );
};
